import { toast } from 'react-toastify';
import { format, parseISO } from 'date-fns'
import { checkISBN } from '../../api/books';
const axios = require('axios');
const URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Brings options for selects from the backend.
 * @param {string} text
 */
const loadAsyncOptions = async (text, setLoading, fieldID, lang) => {
  if (text.length == 0) return [];

  // TODO do search when x time has passed since the last time this event fired off.

  setLoading(true);
  let returnOptions = [];

  try {
    if (fieldID == "collaborators") {
      // Look for authors
      const urlPetition = `${URL}/authors/${text}/search/`;
      const resp = await axios.get(urlPetition).then((resp) => {
        const authors = resp.data.docs;
        const options = authors.map((author) => {
          const fullName = `${author.lastName}, ${author.firstName}`;
          return { value: author._id, label: fullName };
        })
        return options;
      })

      returnOptions = resp;
    } else if (fieldID == "keywords") {
      // Look for keywords somewhere
      return []
    }
    return []
    // There shouldn't be another option.... For now.
  } catch (error) {
    toast.error(lang.ERR_NETWORK);
  } finally {
    setLoading(false);
    return returnOptions;
  }
}

/**
 * Se intenta insertar el libro en la BD. EN caso de fallar, se notifica al usuario la existencia de un
 * error mediante notificaciones. El éxito en el registro también se notifica usando notificaciones.
 * @param {*} values 
 */
const uploadBook = async (values, lang) => {
  let data = JSON.parse(JSON.stringify(values));
  data.authors = data.collaborators.map((author) => { return author.value });
  data.collaborators = data.collaborators.map((author) => { return author.label });
  data.keywords = data.keywords.map((keyword) => { return keyword.value });

  try {
    const urlPetition = `${URL}/books`;
    const response = await axios.post(urlPetition, data);
    toast.success(lang.book.success.create, {
      position: toast.POSITION.TOP_RIGHT,
      className: 'foo-bar'
    });
    // TODO redirect to some kind of page.
  } catch (error) {
    toast.error(lang.ERR_NETWORK);
  }
}

/**
 * Actualiza los datos del libro en la BD. Adicionalmente, retorna si la operación
 * fue exitosa o no.
 * @param {json} values 
 * @returns 
 */
const updateBook = async (values, lang) => {
  const bookId = localStorage.getItem("book");
  let data = JSON.parse(JSON.stringify(values));
  data.authors = data.collaborators.map((author) => { return author.value });
  data.collaborators = data.collaborators.map((author) => { return author.label });
  data.keywords = data.keywords.map((keyword) => { return keyword.value });

  try {
    const urlPetition = `${URL}/books/${bookId}`;
    const response = await axios.put(urlPetition, data);
    toast.success(lang.book.success.update, {
      position: toast.POSITION.TOP_RIGHT,
      className: 'foo-bar'
    });

    return true;
  } catch (error) {
    toast.error(lang.ERR_NETWORK);
    return false;
  }
}

/**
 * Sets 'active' field of book to false, so it wont appear anymore. Returns
 * true if the operation was succesful or not.
 * @returns 
 */
const deleteBook = async (lang) => {
  const bookId = localStorage.getItem("book");

  try {
    const urlPetition = `${URL}/books/${bookId}`;
    const response = await axios.delete(urlPetition);
    toast.success(lang.book.succes.delete, {
      position: toast.POSITION.TOP_RIGHT,
      className: 'foo-bar'
    });

    return true;
  } catch (error) {
    toast.error(lang.ERR_NETWORK);
    return false;
  }
}

/**
 * Transform an array of author object to form: {label: string, value: string}.
 * label being the full name of author, value being the _id in DB.
 * @param {[]JSON} authors 
 * @returns 
 */
const transformAuthors = (authors) => {
  let parsedAuthors = authors.map((author) => {
    return (
      {
        label: `${author.lastName}, ${author.firstName}`,
        value: author._id
      }
    )
  })

  return parsedAuthors;
}


/**
 * Get and transform all book data from database by its ID.
 * @param {json} lang 
 * @returns 
 */
const loadBook = async (lang) => {
  const bookId = localStorage.getItem("book");

  try {
    const response = await axios.get(`${URL}/books/${bookId}`);
    let book = response.data;
    book.authors = transformAuthors(book.authors);
    book.collaborators = book.authors;
    book.creation_date = format(parseISO(book.creation_date), "yyyy-MM-dd");
    // TODO handle image.
    book.cover_image = "";
    book.keywords = Object.keys(book.keywords) == 0 ? [] : book.keywords.map((keyword) => { return { label: keyword, value: keyword } });

    return book;
  } catch (error) {
    //console.log(error);
    toast.error(lang.ERR_NETWORK);
  }
}

const checkISBNExists = async (isbn) => {
  try {
    const req = await checkISBN(isbn);
    const bookExists = req.data.exists;
    return bookExists;
  } catch (error) {
    return true;
  }
}


export { loadAsyncOptions, uploadBook, loadBook, updateBook, deleteBook, checkISBNExists }